import { setTabSelected, setSizeMappings, setSizeGuideModalOpen, setFitNotes } from "slices/pdp-slice";
import { useDispatch, useSelector } from "react-redux";
import { flagsAndExperimentNames } from "rtr-constants";
import { DiscoSearchServiceClient } from "clients/disco-search-service-client";

const SizeGuideButton = () => {
  const dispatch = useDispatch();
  const browser = useSelector(state => state.browser);
  const isMobileViewport = browser?.isMobileViewport;
  const productId = useSelector(state => state?.staticProduct?.productId);
  const enableSizeGuide = useSelector(
    state => state.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_ENABLE_SIZE_GUIDE]
  );

  const fetchProductSizeGuide = async () => {
    const sizeGuideRes = await DiscoSearchServiceClient.getInstance().getSizeGuideByProductId(productId);
    return sizeGuideRes;
  };

  const handleSizeGuideClick = async e => {
    e.preventDefault();
    e.stopPropagation();

    // Fetch size mappings regardless of viewport
    const sizeGuide = await fetchProductSizeGuide();
    dispatch(setSizeMappings(sizeGuide?.sizeMappings));
    dispatch(setFitNotes(sizeGuide?.fitNotes || null));

    if (isMobileViewport) {
      // Scroll to size guide tab for mobile
      dispatch(setTabSelected("Size Guide"));
      const target = document.querySelector(".pdp-product-info__tabs") || null;
      if (target) {
        const topOffset = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: topOffset,
          behavior: "smooth",
        });
      }
    } else {
      // Open modal for desktop
      dispatch(setSizeGuideModalOpen(true));
    }
  };

  if (!enableSizeGuide) return null;

  return (
    <button className="mt-3 flex items-center font-semibold underline" onClick={handleSizeGuideClick}>
      Size Guide
      <span className="reb-DownArrow md:hidden"></span>
    </button>
  );
};

export default SizeGuideButton;
